module.exports = __webpack_public_path__ + "img/diamonds-without@2x.adcb2a1.webp";